import { render, staticRenderFns } from "./InventorySectorLabel.vue?vue&type=template&id=37bdaaa0"
import script from "./InventorySectorLabel.vue?vue&type=script&lang=js"
export * from "./InventorySectorLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports